import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";


import Advanced_Technology from "../images/19.jpg";

const Services = () => {
  const services = [
    {
      icon: "🎓",
      title: "Training & Capacity Building",
      description:
        "Comprehensive training programs for SHG members on dairy management, entrepreneurship, and business skills",
      features: [
        "Dairy farming best practices",
        "Business management skills",
        "Financial literacy programs",
        "Leadership development",
        "Quality control training",
      ],
    },
    {
      icon: "🔬",
      title: "IoT Technology Solutions",
      description:
        "Advanced technology integration for quality testing and fair pricing mechanisms",
      features: [
        "IoT Milk Analyzer for quality testing",
        "Real-time milk composition analysis",
        "Automated pricing based on quality",
        "Digital record keeping",
        "AI/ML solutions for optimization",
      ],
    },
    {
      icon: "🏭",
      title: "Enterprise Development",
      description:
        "Complete support for developing and scaling dairy enterprises within SHGs",
      features: [
        "Business plan development",
        "Equipment and infrastructure support",
        "Product development guidance",
        "Marketing strategy assistance",
        "Scale-up planning",
      ],
    },
    {
      icon: "🤝",
      title: "Buy-back & Market Linkages",
      description:
        "Guaranteed market access and buy-back support for all dairy products",
      features: [
        "Guaranteed buy-back at fair prices",
        "Direct market linkages",
        "Supply chain optimization",
        "Distribution network access",
        "Retail partnership opportunities",
      ],
    },
    {
      icon: "📢",
      title: "Awareness Programs",
      description:
        "Community awareness and education programs on dairy health and nutrition",
      features: [
        "Dairy health camps in villages",
        "Nutrition awareness programs",
        "Animal health workshops",
        "Sustainable farming practices",
        "Community engagement activities",
      ],
    },
    {
      icon: "💰",
      title: "Financial Support Services",
      description:
        "Financial guidance and support for dairy entrepreneurs and SHG members",
      features: [
        "Microfinance facilitation",
        "Government scheme guidance",
        "Credit score improvement",
        "Investment planning",
        "Subsidy application support",
      ],
    },
  ];

  const processSteps = [
    {
      step: "1",
      title: "Assessment",
      desc: "We assess the needs and capabilities of SHG members",
    },
    {
      step: "2",
      title: "Training",
      desc: "Comprehensive training programs tailored to specific needs",
    },
    {
      step: "3",
      title: "Implementation",
      desc: "Support in implementing dairy enterprises with technology",
    },
    {
      step: "4",
      title: "Support",
      desc: "Ongoing support with market linkages and buy-back guarantee",
    },
  ];

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section
        className="py-5 text-white hero_sec"
        style={{ background: "linear-gradient(135deg, #2E8B57, #4682B4)" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-3">Our Services</h1>
              <p className="fs-5">
                Comprehensive support for women dairy entrepreneurs
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Services Grid */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">What We Offer</h2>
              <p className="fs-5 text-muted">
                End-to-end solutions for dairy entrepreneurship success
              </p>
            </Col>
          </Row>
          <Row>
            {services.map((service, index) => (
              <Col lg={4} md={6} key={index} className="mb-4">
                <Card className="border-0 shadow card-hover h-100">
                  <Card.Body className="p-4">
                    <div className="text-center mb-4">
                      <div className="service-icon">{service.icon}</div>
                    </div>
                    <Card.Title className="fw-bold text-center mb-3">
                      {service.title}
                    </Card.Title>
                    <Card.Text className="text-muted text-center mb-4">
                      {service.description}
                    </Card.Text>
                    <ul className="list-unstyled">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="mb-2 small">
                          <span className="text-success me-2">✓</span>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Process Steps */}
      <section
        className="section-padding"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Our Process</h2>
              <p className="fs-5 text-muted">
                How we help SHGs succeed in dairy entrepreneurship
              </p>
            </Col>
          </Row>
          <Row>
            {processSteps.map((process, index) => (
              <Col md={3} key={index} className="text-center mb-4">
                <div className="position-relative mb-4">
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #2E8B57, #4682B4)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "2rem",
                      fontWeight: "bold",
                      margin: "0 auto",
                    }}
                  >
                    {process.step}
                  </div>
                  {index < processSteps.length - 1 && (
                    <div
                      className="d-none d-md-block position-absolute"
                      style={{
                        top: "40px",
                        left: "80px",
                        width: "100%",
                        height: "2px",
                        background:
                          "linear-gradient(to right, #2E8B57, #4682B4)",
                      }}
                    ></div>
                  )}
                </div>
                <h5 className="fw-bold">{process.title}</h5>
                <p className="text-muted">{process.desc}</p>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Technology Showcase */}
      <section className="section-padding">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <h2 className="display-5 fw-bold mb-4">
                Advanced Technology Integration
              </h2>
              <div className="mb-4">
                <h5 className="fw-bold text-primary">🔬 IoT Milk Analyzer</h5>
                <p className="text-muted">
                  Real-time analysis of milk quality parameters including fat,
                  protein, and purity levels
                </p>
              </div>
              <div className="mb-4">
                <h5 className="fw-bold text-primary">🤖 AI/ML Solutions</h5>
                <p className="text-muted">
                  Machine learning algorithms for predictive analytics and
                  optimization
                </p>
              </div>
              <div className="mb-4">
                <h5 className="fw-bold text-primary">📊 Digital Records</h5>
                <p className="text-muted">
                  Comprehensive digital record keeping and analytics dashboard
                </p>
              </div>
              <div className="mb-4">
                <h5 className="fw-bold text-primary">📱 Mobile App</h5>
                <p className="text-muted">
                  User-friendly mobile application for farmers and SHG members
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <img
                src={Advanced_Technology}
                alt="Quality testing"
                className="img-fluid rounded shadow-lg hover-lift"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Training Programs */}
      <section
        className="section-padding"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Training Programs</h2>
              <p className="fs-5 text-muted">
                Building capabilities for sustainable success
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="mb-4">
              <Card className="border-0 shadow-sm hover-lift h-100">
                <Card.Body className="text-center p-4">
                  <div className="service-icon">🐄</div>
                  <h5 className="fw-bold">Dairy Farming</h5>
                  <p className="text-muted">
                    Best practices in dairy farming, animal care, and milk
                    production
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-4">
              <Card className="border-0 shadow-sm hover-lift h-100">
                <Card.Body className="text-center p-4">
                  <div className="service-icon">💼</div>
                  <h5 className="fw-bold">Business Skills</h5>
                  <p className="text-muted">
                    Entrepreneurship, financial management, and business
                    development
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-4">
              <Card className="border-0 shadow-sm hover-lift h-100">
                <Card.Body className="text-center p-4">
                  <div className="service-icon">⚗️</div>
                  <h5 className="fw-bold">Quality Control</h5>
                  <p className="text-muted">
                    Quality testing, food safety, and product standardization
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section
        className="py-5 text-white"
        style={{ background: "linear-gradient(135deg, #2E8B57, #4682B4)" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-3">Ready to Get Started?</h2>
              <p className="fs-5 mb-4">
                Join our comprehensive support program and transform your dairy
                enterprise
              </p>
              <div className="d-flex justify-content-center gap-3">
                <button className="btn btn-light btn-lg px-4">
                  Contact Us Today
                </button>
                <button className="btn btn-outline-light btn-lg px-4">
                  Learn More
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Services;
